/**
 * @enum ConflictSuffix
 */
export enum ConflictSuffix {
  VALUE = "Master",
  CHECKBOX = "Checkbox"
}

/**
 * @enum ConflictType
 */
export enum ConflictType {
  IMAGE = "image",
  DATE = "date",
  TEXT = "text",
  MULTISELECT = "multi-select",
  NESTED_MULTISELECT = "nested-multi-select",
  TAG = "tag",
  EMAIL_LIST = "EMAIL_LIST"
}

export const DISPLAY_ONLY_REMOVED_VALUES_CONFLICT_TYPE_LIST = [
  ConflictType.TAG,
  ConflictType.MULTISELECT,
  ConflictType.NESTED_MULTISELECT,
  ConflictType.EMAIL_LIST
];

export enum ConflictTagType {
  DELETED_VALUE = "DELETED_VALUE",
  NEW_VALUE = "NEW_VALUE"
}
